<app-layout *ngIf="showLayout"></app-layout>
<div [class.impaired]="isImpaired" class="app-container" appCookieAgreement>
<router-outlet></router-outlet>
</div>

<!--<app-inaccessibility></app-inaccessibility>-->
